import { API_BASE, apiInstance } from "../config/api";

const buildTenantPortalUrl = (path: string, phoneNumber: string) => {
  const url = new URL(`${API_BASE}${path}`);
  url.searchParams.set("phoneNumber", phoneNumber);
  return url.toString();
};

export const tenantService = {
  async getTenantProfile(phoneNumber: string) {
    const response = await apiInstance.get("/tenant-portal/tenancies", {
      params: { phoneNumber },
    });
    return response.data;
  },

  async listLeasingAgreements(phoneNumber: string) {
    const response = await apiInstance.get("/tenant-portal/leasing-agreements", {
      params: { phoneNumber },
    });
    return response.data;
  },

  async getLeasingAgreement(agreementId: string, phoneNumber: string) {
    const response = await apiInstance.get(
      `/tenant-portal/leasing-agreements/${agreementId}`,
      {
        params: { phoneNumber },
      },
    );
    return response.data;
  },

  getReceiptUrl({
    tenancyId,
    paymentId,
    phoneNumber,
  }: {
    tenancyId: string;
    paymentId: string;
    phoneNumber: string;
  }) {
    return buildTenantPortalUrl(
      `/tenant-portal/tenancies/${tenancyId}/payments/${paymentId}/receipt`,
      phoneNumber,
    );
  },
};